<template>
  <div v-bind:class="{ 'op--modal-container': true, hide: !show }" >
    <div class="op--modal" @click="close">
      <div class="op--modal-content">
        <div class="_modal" @click.stop>
          <div class="modal-tab">
            <span :class="{'active':isLogin}" @click="isLogin = true">
              <i class="fas fa-user-circle"></i>{{ $t('common.login') }}
            </span>
            <span :class="{'active':!isLogin}" @click="isLogin = false">
              <i class="fas fa-user-plus"></i>{{ $t('common.signup') }}
            </span>
          </div>

          <login-form v-show="isLogin" @loginSuccess="close"></login-form>
          <signup-form v-show="!isLogin" ref="signupForm"></signup-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from './LoginForm'
import SignupForm from './SignupForm'

export default {
  name: 'login-signup',
  components: { LoginForm, SignupForm },
  data () {
    return {
      isLogin: true,
      loginForm: {
        username: '',
        password: ''
      },
      formNumber: 1,
      corporateInfo: {
        logo: ''
      }
    }
  },
  computed: {
    show () { return this.$store.state.loginSignup.show }
  },
  methods: {
    close () {
      let self = this
      if (self.$refs.signupForm.resetResponse()) {
        self.$refs.signupForm.resetResponse()
      }
      self.$store.commit('loginSignup/hideModal')
      document.getElementsByTagName('body')[0].removeAttribute('style', 'overflow: hidden!important;')
      document.body.classList.remove('widget-no-scroll')
      if (document.querySelectorAll('.top-bar.dynamic')[0]) {
        document.querySelectorAll('.top-bar.dynamic')[0].removeAttribute('style', 'z-index:2;')
      }
      if (document.querySelectorAll('#desktopMenu')[0]) {
        document.querySelectorAll('#desktopMenu')[0].removeAttribute('style', 'z-index:100;')
        document.querySelectorAll('#mobileMenu')[0].removeAttribute('style', 'z-index:100;')
      }
    },
    showForm (form) {
      let self = this
      if (form === self.formNumber) {
        return true
      } else {
        return false
      }
    },
    nextForm () {
      let self = this
      self.formNumber = self.formNumber + 1
    },
    backForm () {
      let self = this
      self.formNumber = self.formNumber - 1
    }
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container{ overflow: auto; }
._modal {
  background-color: #fff;
  max-width: 510px;
  margin: 0 auto;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  font-family: 'Questrial', sans-serif;
}

.modal-tab{
  margin-bottom: 10px;
  display: flex;

  span{
    background: #f6f6f6;
    border-bottom: 1px solid #ddd;
    padding: 18px;
    text-align: center;
    width: 50%;
    display: inline-block;
    cursor: pointer;
    color: #555;
    font-size: 17px;

    i{ margin-right: 5px; }
    &.active{
      background: #fff;
      border: none;
    }
    &:not(.active){
      box-shadow: 0 -1px 1px rgba(0,0,0, .05) inset;
      color: #aaa;
    }
    &:first-child:not(.active){ border-right: 1px solid #ddd }
    &:last-child:not(.active){ border-left: 1px solid #ddd }
  }
}

.modal-box {
  padding: 20px;
  & .line-break {
    border: 1px solid #dedede;
    border-bottom-width: thin;
    display: block;
    margin: 15px 0;
  }
  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 5px;
  }

  .column {
    padding: 0 5px;
    margin-bottom: 10px;
  }

  input {
    margin: 0;
    color: #333;
    line-height: inherit;
    -webkit-transition: all .15s ease;
    transition: all .15s ease;
    width: 100%;
    position: relative;
    z-index: 1;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    height: 40.4px;
    border-radius: 0;
    width: 100%;
    border: none;
    border: 1px solid #ccc;
    padding: 10px;
    background: #fbfbfb;
    color: #444;
    outline: none;
    -webkit-box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);
    box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);
    -webkit-transition: all .3s linear;
    transition: all .3s linear;
  }
}
</style>



// WEBPACK FOOTER //
// LoginSignupModal.vue?59409ecd